import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPowershellComponent } from './simple-icons-powershell.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPowershellComponent ],
    exports:      [ SimpleIconsPowershellComponent ],
    bootstrap:    []
})
export class SimpleIconsPowershellModule {}
